import { render, staticRenderFns } from "./tabSelect.vue?vue&type=template&id=f9e2ba9e&scoped=true&"
import script from "./tabSelect.vue?vue&type=script&lang=ts&"
export * from "./tabSelect.vue?vue&type=script&lang=ts&"
import style0 from "./tabSelect.vue?vue&type=style&index=0&id=f9e2ba9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e2ba9e",
  null
  
)

export default component.exports